module.exports = __webpack_public_path__ + "img/about3.27fbd5ab.jpg";